import React, { Component } from 'react';
import { connect } from 'react-redux';
import './SubPageTopBar.css';
import { setSubPage } from '../../../redux/actions';
import BackButton from '../BackButton/BackButton';
import * as utils from '../../../utils';

// note - try to stick close btn to top

class SubPageTopBar extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.setSubPage('');
    utils.scrollToTop();
  }

  render() {
    return (
      <div className="sub-page-topbar">
        <BackButton onClick={this.handleClick} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setSubPage: pageId => dispatch(setSubPage(pageId)),
});

export default connect(null, mapDispatchToProps)(SubPageTopBar);



// WEBPACK FOOTER //
// ./src/components/Shared/SubPageTopBar/SubPageTopBar.js